import { Controparte } from './controparte';
import { DocumentoAllegato } from './documento-allegato';
import { GruppoVisibilita } from './gruppo-visibilita';
import { IncassoSoggetto } from './incasso-soggetto';
import { ModalitaPagamento } from './tipologiche/modalita-pagamento';
import { TipoPagamento } from './tipologiche/tipo-pagamento';

export class Incasso {
  id: string;
  dataIncasso: number;
  causale: string;
  soggettoPagatore: Controparte;
  areaCompetente: GruppoVisibilita;
  importo: any;
  interessi: any;
  spese: any;
  compensoAvvocati: any;
  tipoIncasso: TipoPagamento;
  modalitaIncasso: ModalitaPagamento;
  note: string;
  documenti: DocumentoAllegato[];
  //importoIncasso: number;
  importoPattuito: number;
  incassiSoggetti: IncassoSoggetto[];
}
